module.exports = __webpack_public_path__ + "static/media/del-gallery.8f9dd0c7.svg";